import { memo, useState, useCallback, useEffect } from 'react';
import { Box, Button, CardContent, FormHelperText, InputLabel, MenuItem, Select, TextField, Typography, FormControl, Grid, IconButton, Card, CardMedia, Modal, } from "@mui/material";
import Cropper from "react-easy-crop";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDispatch, useSelector } from "react-redux";
import { nextStep, resetAndUpdate, update } from '../../../../../slice/multiStepSlice';
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import showToast from "../../../../../components/Hot-Toast/showToast";
import { useTMutation } from "../../../../../utils/useTMutation";
import getCroppedImg from '../../../../../components/Cropper/cropImage';
import { TrainingCertificateSchema } from '../../../../../hooks/validationSchema';
import { API_URL } from "../../../../../appConstants";



const AddTraining = ({ data }) => {
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep);
    const { userDetails } = useSelector((state) => state?.user);
    const [image, setImage] = useState(null);  // Stores the final cropped image
    // ==============For Crop Image Start==============
    const [file, setFile] = useState();
    const [openCropImageModal, setOpenCropImageModal] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [actualFile, setActualFile] = useState();

    const { register, setValue, watch, handleSubmit, control, formState: { errors } } = useForm({
        resolver: zodResolver(TrainingCertificateSchema(image)),
        defaultValues: {
            trainingCertificateName: values.trainingCertificateName || '',
            requirementType: values.requirementType || '',
            trainingImage: values.trainingImage ? (API_URL + `user/viewFile?fileName=${values.trainingImage}`) : ''
        }
    });
    const watchedImage = watch("trainingImage");

    useEffect(() => {
        if (!file)
            setImage(watchedImage);
    }, [file, watchedImage]);

    //save the training data
    const { mutateAsync } = useTMutation("/addUpdateTrainingCertificates", "post",
        (response) => response.STATUS ? response : null);

    const submitTrainingData = async (data) => {
        try {
            if (userDetails.USER_TYPE !== 'admin') {
                showToast('error', 'Session expired!!, Please login again', 3000)
            }
            const formData = new FormData();
            if (typeof data.trainingImage === "object") {
                formData.append("file", data.trainingImage, actualFile.name);
            }
            formData.append("trainingCertificateName", data?.trainingCertificateName);
            formData.append("requirementType", data?.requirementType);
            formData.append("USER_ID", userDetails.ID);
            if (values.ID) formData.append("ID", values?.ID);

            const response = await mutateAsync(formData);
            showToast(response.STATUS ? "success" : "error", response.MESSAGE, 3000);
            if (response?.STATUS) {

                dispatch(update(response.OUTPUT));
                // dispatch(update(values.ID ? data : response.OUTPUT));
                dispatch(nextStep());
            }
        } catch (error) {
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };
    // Handle file selection
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file && file.size < 5 * 1024 * 1024) {
            setFile(URL.createObjectURL(file));
            setActualFile(file);
            setOpenCropImageModal(true);
        } else {
            showToast('error', "Please select an image smaller than 5MB.");
        }
    };
    const saveCropedImage = useCallback(async () => {
        try {
            if (!croppedAreaPixels || !file || !actualFile) return;

            // Get cropped image as a Blob URL
            const croppedImageUrl = await getCroppedImg(file, croppedAreaPixels);

            // Convert Blob URL to File
            const blob = await fetch(croppedImageUrl).then((r) => r.blob());
            const myFile = new File([blob], actualFile.name, { type: "image/png" });

            setValue("trainingImage", myFile);
            // setCropImage(myFile);
            setImage(croppedImageUrl);  // Update the preview image
            setOpenCropImageModal(false);

        } catch (e) {
            console.error("Error cropping image:", e);
        }
    }, [actualFile, croppedAreaPixels, file, setValue]);
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleCropCancel = async () => {
        setOpenCropImageModal(false);
        setDynamicAspect(1 / 1);
    };
    const handleBackdropClick = (event) => {
        event.stopPropagation(); // Prevent backdrop click from closing modal
    };
    return (
        <Grid container justifyContent="center">
            <Grid item lg={6} md={8} sm={10} xs={12}>
                <Card>
                    <Typography variant="h5" mt={2} fontWeight="bold" textAlign="center" gutterBottom>Add Learning</Typography>
                    <CardContent>
                        <form onSubmit={handleSubmit(submitTrainingData)}>
                            {/* Training&Learning Banner image */}
                            <Box position="relative" sx={{ width: "100%", height: "250px", backgroundColor: "#f0f0f0" }}>
                                <CardMedia
                                    component="img"
                                    image={image || ""}
                                    alt="Banner Image"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: image ? "cover" : "contain",
                                        backgroundColor: image ? "transparent" : "#e0e0e0",
                                    }}
                                />


                                {/* Camera Icon inside Image */}
                                <IconButton
                                    component="label"
                                    sx={{
                                        position: "absolute",
                                        bottom: 10, // Adjust position inside the image
                                        right: 10,  // Adjust position inside the image
                                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                                        boxShadow: 1,
                                    }}
                                >
                                    <CameraAltIcon fontSize="small" />
                                    <input type="file" hidden accept="image/*"
                                        onChange={handleImageUpload} />
                                </IconButton>
                                {errors.trainingImage && <FormHelperText error>{errors.trainingImage?.message}</FormHelperText>}
                                {/* {errors?.trainingImage &&
                                    <Typography color="error" variant="body2" mt={0.8}>
                                        {errors?.trainingImage?.message}
                                    </Typography>
                                } */}
                            </Box>

                            <Box mt={2}>

                                <TextField
                                    label="Training Certificate Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    {...register("trainingCertificateName")}
                                    error={!!errors.trainingCertificateName}
                                    helperText={errors.trainingCertificateName?.message}
                                />

                            </Box>
                            <FormControl fullWidth sx={{ marginTop: 3 }} error={!!errors.requirementType}>

                                <Controller
                                    name="requirementType"

                                    control={control}
                                    render={({ field }) => (
                                        <>
                                            <InputLabel id="demo-simple-select-label">Requirement</InputLabel>
                                            <Select
                                                // autoFocus
                                                labelId="demo-simple-select-label"
                                                id="requirement-select"
                                                label="Training Type"
                                                {...field}
                                                error={!!errors.requirementType}
                                            >
                                                <MenuItem disabled value="">Select Requirement</MenuItem>
                                                <MenuItem value="Optional">Optional</MenuItem>
                                                <MenuItem value="Mandatory">Mandatory</MenuItem>
                                            </Select></>
                                    )}
                                />
                                {errors.requirementType && <FormHelperText error>{errors.requirementType?.message}</FormHelperText>}
                            </FormControl>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                                <Button
                                    className='gradientAdminThemeColor'
                                    // variant="contained" sx={{ backgroundColor: '#6ebe44' }}
                                    type='submit'>
                                    Next
                                </Button>
                            </Box>
                        </form>

                        {openCropImageModal && (
                            <Modal
                                open={openCropImageModal}
                                onClose={handleCropCancel}
                                onClick={handleBackdropClick} // Prevent backdrop click from closing modal
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Grid
                                    container
                                    className="crop-image-wrapper"
                                    id="modal-modal-title"
                                    style={{
                                        width: "90vw",
                                        height: "90vh",
                                        maxWidth: "800px",
                                        maxHeight: "600px",
                                        backgroundColor: "#000",
                                        padding: "20px",
                                        borderRadius: "10px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}

                                >
                                    {/* Image Cropper */}
                                    <Grid item style={{ width: "100%", height: "80%", position: "relative" }}>
                                        <Cropper
                                            image={file}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={dynamicAspect}
                                            onCropChange={setCrop}
                                            onCropComplete={onCropComplete}
                                            onZoomChange={setZoom}
                                            style={{ width: "100%", height: "100%" }}
                                        />
                                    </Grid>

                                    {/* Controls */}
                                    <Grid
                                        container
                                        spacing={2}
                                        className="crop-control"
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginTop: "20px"
                                        }}
                                    >
                                        <Grid item>
                                            <Typography style={{ color: "white", fontSize: "12px" }}>
                                                Aspect Ratio
                                            </Typography>
                                            <select
                                                onChange={(e) => setDynamicAspect(parseFloat(e.target.value))}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <option>1/1</option>
                                                <option value="1.23">1.23/1</option>
                                                <option value="1.33">1.33/1</option>
                                                <option value="1.43">1.43/1</option>
                                                <option value="1.625">1.66/1</option>
                                                <option value="2">4/2</option>
                                                <option value="1.7">16/9</option>
                                            </select>
                                        </Grid>
                                        <Grid item>
                                            <Typography style={{ color: "white", fontSize: "12px", textAlign: "center" }}>
                                                Zoom
                                            </Typography>
                                            <input
                                                type="range"
                                                value={zoom}
                                                min={1}
                                                max={11}
                                                step={0.1}
                                                onChange={(e) => setZoom(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Button style={{ backgroundColor: "green", color: "white" }} onClick={saveCropedImage}>
                                                Crop
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleCropCancel}>
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Modal>
                        )}

                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};
export default memo(AddTraining);

